import React, { useEffect, useState, useContext } from "react";
import PieChart from "./PieChart";
import LineChart from "./Line";
import BarChart from "./BarChart";
import "./dashBoard.css";
import { getUserData } from "../../common/utility/Utils";
import axios from "axios";
import { StoreContext } from "../../../store/Provider";
import { CircularProgress } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { basename, HOST_URL, LOCAL_STORAGE_KEY } from "../../../config";
import MainLayout from "../../common/Layout/MainLayout";

const Dashboard = () => {
  const [invoiceData, setInvoiceData] = useState([]);
  const [shipmentStats, setShipmentStats] = useState([]);
  const [transitTime, setTransitTime] = useState([]);
  const [arriveStats, setArriveStats] = useState([]);
  const [shipmentType, setShipmentType] = useState([]);
  const [statusShip, setStatusShip] = useState([]);
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [statics, setStatics] = useState({});
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  useEffect(() => {
    if (context.dashboardData.loaded) {
      dataForGraphs(context.dashboardData.data);
    } else {
      getDashboardData();
    }
  }, []);

  const getDashboardData = async () => {
    let data = {};
    setLoading(true);
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };

    let END_POINT = `${HOST_URL}api/GetAllKPIs?company_code=${data.user_company_code}`;
    axios
      .get(
        END_POINT
        //     , {
        //     headers: header
        // }
      )
      .then((res) => {
        if (res.data.response_code == "1") {
          context.setDashboardData({
            loaded: true,
            data: res.data.response.KPIs,
          });
        }
        dataForGraphs(res.data.response.KPIs);
        console.log("dashboard response", res);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        context.setDashboardData({ loaded: false, data: [] });
        setOpen(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const dataForGraphs = (data) => {
    let stats = {};
    if (data) {
      data.forEach((element, index) => {
        if (index === 0) {
          setInvoiceData(element.summary);
          stats.totalInvoice = element.summary[0].Total;
        }

        if (index === 1) {
          element.summary.forEach((element, i) => {
            if (i === 0) {
              stats.Intransit = element.ValueCount;
            } else {
              stats.Arrived = element.ValueCount;
            }
          });
        } else if (index === 2) {
          setShipmentType(element.summary);
        } else if (index === 3) {
          stats.TotalShipments = element.summary[0].TotalShipments;
          stats.Volume = element.summary[0].Volume;
          stats.Quantity = element.summary[0].Quantity;
          setShipmentStats(element.summary[0].SailingLines);
        } else if (index === 4) {
          setTransitTime(element.summary);
        } else if (index === 5) {
          setStatusShip(element.summary);
        }
      });
    }

    setStatics(stats);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <div className="loadingClass">
          <CircularProgress size="1.5rem" />
        </div>
      ) : (
        <div className="dashComponent">
          <div className="dashHeader">
            <h6>Detailed view of your dashboard</h6>
          </div>
          <div className="dashBody">
            <div className="dashboardUpperRow">
              <div className="uRFirst">
                <h6 className="graphTitle">
                  Invoice Amount (Values in thousand)
                </h6>
                <div className="graphLowerportionDiv">
                  <BarChart type="transit" data={invoiceData} />
                </div>
              </div>
              <div className="uRSecond">
                <h6 className="graphTitle">Shipping Type</h6>
                <div className="graphLowerportionDiv">
                  <PieChart type="type" data={shipmentType} />
                </div>
              </div>
              <div className="uRThird">
                <h6 className="graphTitle">Total Invoice Amount</h6>
                <div className="urThirdUpper">
                  ${context.calculateAmmount(statics.totalInvoice)} K
                </div>
                <h6 className="graphTitle">Shipment status</h6>
                <div className="urThirdLower">
                  <div>
                    <img
                      alt="vehicle"
                      src={`/${basename}/Assets/Images/Truck.svg`}
                    />
                    <p>Loaded - In Transit</p>
                    <span>{statics.Intransit}</span>
                  </div>
                  <div>
                    <img alt="box" src={`/${basename}/Assets/Images/Box.svg`} />
                    <p>Delivered</p>
                    <span>{statics.Arrived}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboardLowerRow">
              <div className="lRFirst">
                <h6 className="graphTitle">Shipment Stats</h6>
                <div className="grapTitleDiv">
                  <div>
                    <span>Total Shipment</span>
                    <p>{statics.TotalShipments}</p>
                  </div>
                  <div>
                    <span>Quantity</span>
                    <p>{statics.Quantity} kg</p>
                  </div>
                  <div>
                    <span>Volume</span>
                    <p>
                      {statics.Volume} m<sup>3</sup>
                    </p>
                  </div>
                </div>
                <div className="graphLowerportionDiv">
                  <BarChart type="stats" data={shipmentStats} />
                </div>
              </div>
              <div className="lRSecond">
                <h6 className="graphTitle">Average Transit Time</h6>
                <p className="graphPara">
                  No. of shipments v/s transit time in weeks
                </p>
                <div className="graphLowerportionDiv">
                  <LineChart data={transitTime} />
                </div>
              </div>
              <div className="lRThird">
                <h6 className="graphTitle">Arrival on time</h6>
                <p className="graphPara">
                  Based on estimated arrival v/s actual vessel discharge date
                </p>
                <div className="graphLowerportionDiv">
                  <PieChart type="" data={statusShip} />
                </div>
              </div>
            </div>
          </div>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <Alert severity={severity} onClose={handleClose}>
              {alertText}
            </Alert>
          </Snackbar>
        </div>
      )}
    </>
  );
};

export default Dashboard;
